import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithGuestSiteHealthProvider, useGuestSiteHealth] = createComponentHealth('GuestSite');
